/**
 * @generated SignedSource<<b4e4a0db2a36571763e65db1fea80f05>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssueTable807BadPattern$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GroupTableBody925BadPattern" | "TableBody195BadPattern">;
  readonly " $fragmentType": "IssueTable807BadPattern";
};
export type IssueTable807BadPattern$key = {
  readonly " $data"?: IssueTable807BadPattern$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueTable807BadPattern">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "IssueTable807BadPattern",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "TableBody195BadPattern"
    },
    {
      "kind": "FragmentSpread",
      "name": "GroupTableBody925BadPattern"
    }
  ],
  "type": "JiraJqlFieldWithAliases"
};

(node as any).hash = "bd060d92c4cbc501618574a84785486e";

export default node;
